<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="query-form">
      <el-form label-position="right" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="注册日期">
                  <el-date-picker
                    style="width:100%"
                    v-model="daterange"
                    type="daterange"
                    value-format="timestamp"
                    :editable="false"
                    :default-time="['00:00:00', '23:59:59']"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="用户ID/名字/手机号" label-width="150px">
                  <div style="display: flex">
                    <el-input v-model="queryForm.keywordList" clearable></el-input>
                    <el-button @click="showBatchVendorForm" style="width: 70px;padding-left: 0;padding-right: 0;background-color: #F5F7FA;">批量</el-button>
                  </div>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺状态">
                  <el-select v-model="queryForm.sellerStatus" clearable placeholder="请选择">
                    <el-option label="正常" :value="1"></el-option>
                    <el-option label="注销" :value="2"></el-option>
                    <el-option label="黑名单" :value="3"></el-option>
                    <el-option label="禁止接单" :value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="toolbar">
      <div class="left">
        <el-button type="primary" @click="batchOutage">禁止接单</el-button>
        <el-button type="primary" @click="batchBlacklist">拉入黑名单</el-button>
        <el-button type="primary" @click="batchLogout">注销</el-button>
        <el-button type="primary" @click="batchRecover">恢复正常运营</el-button>
      </div>
      <el-button type="primary" @click="exportExcel">导出</el-button>
    </div>
    <el-table :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="registerTime" label="注册时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.registerTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="卖家名称"></el-table-column>
      <el-table-column prop="appUserId" label="用户ID"></el-table-column>
      <el-table-column prop="phoneNum" key="mobile" label="手机号">
        <template slot-scope="scope">
          <el-link type="primary" @click="showMobile(scope.row)">{{ scope.row.phoneNum }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="isIdentityAuth" key="mobile" label="是否实名认证">
        <template slot-scope="scope">
          {{ scope.row.isIdentityAuth ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="numOfOnSaleSku" label="在售商品数量"></el-table-column>
      <el-table-column label="店铺状态">
        <template slot-scope="scope">
          {{ scope.row.vendorStatus === '注销' ? '注销' : sellerStatusMapToStr(scope.row.sellerStatus) }}
        </template>
      </el-table-column>
      <el-table-column prop="action" label="操作" width="150px">
        <template slot-scope="scope" v-if="scope.row.vendorStatus === '正常'">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="el-dropdown-link" @click.native="disableTakeBuyOffer(scope.row)">禁止接单</el-dropdown-item>
              <el-dropdown-item class="el-dropdown-link" v-if="scope.row.sellerStatus === 1 || scope.row.sellerStatus === 4" @click.native="addToBlackList(scope.row)">拉入黑名单</el-dropdown-item>
              <el-dropdown-item class="el-dropdown-link" v-if="scope.row.sellerStatus === 3 || scope.row.sellerStatus === 4" @click.native="recover(scope.row)">恢复正常运营</el-dropdown-item>
              <el-dropdown-item class="el-dropdown-link" @click.native="logoutItem(scope.row)">注销</el-dropdown-item>
              <el-dropdown-item class="el-dropdown-link" v-if="pollWelfareBtn" @click.native="pollWelfare(scope.row)">问卷福利</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>

<!--        <template slot-scope="scope">-->
<!--          <el-link type="primary" @click="(scope.row)">禁止接单</el-link>-->
<!--          <el-link type="primary" @click="logoutItem(scope.row)">拉入黑名单</el-link>-->
<!--          <el-link type="primary" @click="logoutItem(scope.row)">注销</el-link>-->
<!--          <el-link type="primary" class="ml10" v-if="pollWelfareBtn" @click="pollWelfare(scope.row)">问卷福利</el-link>-->
<!--        </template>-->
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <el-dialog title="批量输入用户ID/名字/手机号" :visible.sync="dialogVisibleBatchVendor" :close-on-click-modal="false" width="500px">
      <p class="mb10">请输入用户ID/名字/手机号（一行一个，最多1000个）：</p>
      <el-input
        type="textarea"
        :rows="14"
        v-model="inputVendorStr">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBatchVendor = false">取 消</el-button>
        <el-button type="primary" @click="submitInputVendorStr">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="禁止接单" :visible.sync="dialogVisibleOutage" :close-on-click-modal="false" width="500px">
      <BrandSelect :data="brandList" v-model="brandIds" multiple clearable style="width: 220px" placeholder="全部品牌"></BrandSelect>
      <el-cascader ref="Cascader" class="ml10" v-model="categoryIds" :options="categoryList" :props="optionProps" clearable style="width: 220px" placeholder="全部品类"></el-cascader>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleOutage = false">取 消</el-button>
        <el-button type="primary" @click="submitBatchOutage">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import utils from '@/utils/util';
import { downloadUrlFile } from '@/utils/functions';
import BrandSelect from '../shared/brandSelect.vue';
import {
  getSellerUserList,
  exportSellerUserList,
  getMobile,
  updateVendorStatus,
  bindUserCampaign,
  updateSellerStatus,
  getBrandList,
  getCategory,
} from "./api";

export default {
  components: {
    BrandSelect,
  },
  data() {
    return {
      fullscreenLoading: false,
      daterange: [],
      queryForm: {
        pageNo: 1,
        pageSize: 25,
        keywordList: []
      },
      tableData: [],
      total: 0,
      dialogVisibleBatchVendor: false,
      inputVendorStr: '',
      multipleSelection: [],
      dialogVisibleOutage: false,
      brandList: [],
      categoryList: [],
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true,
        label: 'chineseName',
        value: 'categoryId',
      },
      brandIds: [],
      categoryIds: [],
    };
  },
  computed: mapState({
    pollWelfareBtn: (state) => state.app.menuMap['个人卖家-用户列表-问卷福利'],
  }),
  mounted() {
    getBrandList().then(res => {//获取品牌列表
      this.brandList = (res.data || []).map(item => {
        return {
          label: item.englishName,
          value: item.brandId
        };
      });
    });
    getCategory().then(res => {
      this.categoryList = res.data || [];
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    // 4: 禁止接单
    // 3: 冻结店铺
    // 1: 正常
    sellerStatusMapToStr(sellerStatus){
      switch (sellerStatus){
        case 1:
          return "正常";
        case 3:
          return "冻结";
        case 4:
          return "禁止接单";
      }
    },
    reset() {
      this.daterange = [];
      this.queryForm.pageNo = 1;
      this.queryForm.keywordList = [];
      this.getTableData();
    },
    getTableData() {
      if(!Array.isArray(this.queryForm.keywordList)){
        if(this.queryForm.keywordList){
          this.queryForm.keywordList = [this.queryForm.keywordList]
        }else {
          this.queryForm.keywordList = []
        }
      }
      getSellerUserList({
        ...this.queryForm,
        startDate: this.daterange ? this.daterange[0] : null,
        endDate: this.daterange ? this.daterange[1] : null,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    exportExcel() {
      if (!this.daterange || this.daterange.length === 0) {
        this.$message('请选择日期后导出');
        return;
      }
      this.fullscreenLoading = true;

      if(!Array.isArray(this.queryForm.keywordList)){
        if(this.queryForm.keywordList){
          this.queryForm.keywordList = [this.queryForm.keywordList]
        }else {
          this.queryForm.keywordList = []
        }
      }

      exportSellerUserList({
        ...this.queryForm,
        startDate: this.daterange ? this.daterange[0] : null,
        endDate: this.daterange ? this.daterange[1] : null,
      }).then(res => {
        if (res.data && res.data.data) {
          downloadUrlFile(res.data.data);
        }
        this.fullscreenLoading = false;
      }).catch(() => {
        this.$message.error('系统异常');
        this.fullscreenLoading = false;
      })
    },
    showMobile(row) {
      getMobile(row.appUserId).then(res => {
        if (res.data && res.data.success) {
          this.$alert(`手机号：${res.data.data}`, '警告', {
            type: 'warning',
            confirmButtonText: '确定',
          });
        }
      });
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    logoutItem(row) {
      console.log(11111)
      this.$confirm(`确认注销该用户？`, '确认', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true;
        updateVendorStatus({
          vendorId: row.vendorId,
          destroyChannel: 4, // 固定
          userId: row.appUserId,
          vendorStatus: 5, // 固定
        }).then((res) => {
          if (res.data && res.data.success) {
            this.$message.success('操作成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
          this.fullscreenLoading = false;
        }).catch(() => {
          this.fullscreenLoading = false;
        });
      }).catch(() => {});
    },
    batchLogout() {
      if (this.multipleSelection.length === 0) {
        this.$message('请选择要注销的用户');
        return;
      }
      this.$confirm(`确认注销选中的${this.multipleSelection.length}个用户？`, '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true;
        updateVendorStatus({
          vendorIds: this.multipleSelection.map(item => item.vendorId),
          destroyChannel: 4, // 固定
          userIds: this.multipleSelection.map(item => item.appUserId),
          vendorStatus: 5, // 固定
        }).then((res) => {
          if (res.datqa && res.data.success) {
            this.$message.success('操作成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
          this.fullscreenLoading = false;
        }).catch(() => {
          this.fullscreenLoading = false;
        });
      }).catch(() => {});
    },
    // 4: 禁止接单
    // 3: 冻结店铺
    // 1: 正常
    updateSellerStatus(vendorIds,sellerStatus, categoryIds, brandIds) {
      this.fullscreenLoading = true;
      updateSellerStatus({
        vendorIds,
        sellerStatus: sellerStatus,
        buyOfferBlackConfig: {
          categoryIds: categoryIds ? categoryIds : null,
          brandIds: brandIds ? brandIds : null,
        },
      }).then((res) => {
        if (res.data && res.data.success) {
          this.$message.success('操作成功');
          this.getTableData();
          this.dialogVisibleOutage = false;
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
        this.fullscreenLoading = false;
      }).catch(() => {
        this.fullscreenLoading = false;
      });
    },
    batchBlacklist() {
      if (this.multipleSelection.length === 0) {
        this.$message('请选择要拉入黑名单的用户');
        return;
      }
      this.$confirm(`确认将选中的${this.multipleSelection.length}个用户拉入黑名单？`, '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true;
        this.updateSellerStatus(this.multipleSelection.map(item => item.vendorId),3)
        this.fullscreenLoading = false;
      }).catch(() => {});
    },
    addToBlackList(row){
      this.$confirm(`确认将该店铺冻结？`, '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateSellerStatus([row.vendorId],3)
      }).catch(() => {});
    },

    recover(row){
      this.$confirm(`确认回复正常运营？`, '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateSellerStatus([row.vendorId],1)
      }).catch(() => {});
    },

    batchOutage() {
      if (this.multipleSelection.length === 0) {
        this.$message('请选择要禁止接单的用户');
        return;
      }
      this.brandIds = [];
      this.categoryIds = [];
      this.currVendorIds = this.multipleSelection.map(item => item.vendorId);
      this.dialogVisibleOutage = true;
    },

    batchRecover() {
      if (this.multipleSelection.length === 0) {
        this.$message('请选择要恢复的用户');
        return;
      }
      this.$confirm(`确认将选中的${this.multipleSelection.length}个用户恢复正常运营？`, '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true;
        this.updateSellerStatus(this.multipleSelection.map(item => item.vendorId),1)
        this.fullscreenLoading = false;
      }).catch(() => {});
    },
    disableTakeBuyOffer(row) {
      if (row.buyOfferBlackConfig) {
        this.brandIds = row.buyOfferBlackConfig.brandIds || [];
        this.categoryIds = row.buyOfferBlackConfig.categoryIds || [];
      } else {
        this.brandIds = [];
        this.categoryIds = [];
      }
      this.currVendorIds = [row.vendorId];
      this.dialogVisibleOutage = true;
    },
    submitBatchOutage() {
      this.$confirm(`确认禁止接单？`, '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.updateSellerStatus(this.currVendorIds, 4, this.categoryIds, this.brandIds);
      }).catch(() => {});
    },
    pollWelfare(row) {
      this.$confirm(`确认为该用户设置问卷福利？`, '确认', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true;
        bindUserCampaign({
          appUserId: row.appUserId,
        }).then((res) => {
          if (res.data && res.data.success) {
            this.$message.success('操作成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
          this.fullscreenLoading = false;
        }).catch(() => {
          this.fullscreenLoading = false;
        });
      }).catch(() => {});
    },
    showBatchVendorForm() {
      this.inputVendorStr = '';
      this.dialogVisibleBatchVendor = true;
    },
    submitInputVendorStr() {
      const idList = this.inputVendorStr.split('\n').filter(item => item.trim()).map(item => item.trim());
      if (idList.length === 0) {
        this.$message('请输入用户ID/名字/手机号');
        return;
      }
      if (idList.length > 1000) {
        this.$message.error('输入行数不允许超过1000，请重新输入');
        return;
      }
      this.queryForm.keywordList = idList;
      this.dialogVisibleBatchVendor = false;
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.el-dropdown-link{
  cursor: pointer;
  color: #409EFF;
}
</style>
